import { euCountryCodes } from "./euCountryCodes";

// Countries where private individuals (no VAT ID) can purchase.
// All EU member states; German VAT applies (see `TopupTaxPolicy.carchesVat`).

export const privateCountryCodes = new Set(euCountryCodes);
